import '/vercel/path0/packages/storybook-addon/dist/cjs/manager.cjs';